module.exports = __webpack_public_path__ + "static/img/banner-es.0e678ec3.webp";